import { render, staticRenderFns } from "./GroupsCreateOrEdit.vue?vue&type=template&id=a1249fc6&scoped=true&"
import script from "./GroupsCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./GroupsCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupsCreateOrEdit.vue?vue&type=style&index=0&id=a1249fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1249fc6",
  null
  
)

export default component.exports